<template>
  <div v-if="props.loading">
    <a-skeleton active :title="false" :paragraph="{ rows: 8 }" />
  </div>
  <div v-else style="display: flex; flex-direction: column; gap: 16px">
    <div v-for="type in props.types" :key="type.id">
      <NotificationTypeSection
        :loading="props.loading"
        :action-loading="props.actionLoading"
        :type="type"
        :rules="getRulesForType(type.id)"
        @edit="handleEdit"
        @delete="handleDelete"
      />
    </div>
  </div>
</template>

<script setup>
import NotificationTypeSection from '../ui/notification-type-section.vue';
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  types: {
    type: Array,
    required: true
  },
  rules: {
    type: Array,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  },
  actionLoading: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['edit', 'delete']);

const getRulesForType = (typeId) => {
  return props.rules.filter(
    (rule) => rule.companyNotificationTypeId === typeId
  );
};

const handleEdit = (rule) => {
  emit('edit', rule);
};

const handleDelete = (rule) => {
  emit('delete', rule);
};
</script>
